import React from 'react';
import styled from 'styled-components';
import Logo from '../Logo/Logo';
import { Web3Connect } from '../Web3Connect/Web3Connect';
import { BreakpointUpContainer } from '../../styles/Breakpoints';
import ChainHandler from '../ChainHandler/ChainHandler';

const Navbar = ({ globalState, setGlobalState }) => {
  return (
    <>
      <Header>
        <Nav>
          <Logo to="/" altText="polybet" />
          <Web3Connect globalState={globalState} setGlobalState={setGlobalState} />
        </Nav>
      </Header>

      <ChainHandler globalState={globalState} setGlobalState={setGlobalState} />
    </>
  );
};

export default Navbar;

const Header = styled.header.attrs({ className: 'navbar' })`
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  border-bottom: 1px solid hsl(222 47% 15%);
  background: hsl(222 47% 6% / 0.8);
  backdrop-filter: blur(16px);
`;

const Nav = styled.nav.attrs({ className: 'navbar__container' })`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 16px;

  ${BreakpointUpContainer} {
    max-width: 1360px;
    margin-left: auto;
    margin-right: auto;
  }
`;
